export const SET_MIGRATION_FIELDS_FOR_CONFIRM= 'SET_MIGRATION_FIELDS_FOR_CONFIRM'
export const SET_MIGRATION_SHOW_CONTENT_FOR_LINK_EXPIRED= 'SET_MIGRATION_SHOW_CONTENT_FOR_LINK_EXPIRED'
